<template>
    <div>
        <b-modal
            id="add-system-user-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="User Name"
                            label-for="user-name"
                        >
                            <b-form-input
                                id="user-name"
                                v-model="formData.username"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^\S*$/,
                                }"
                                name="user name"
                                type="text"
                                :class="{
                                    'is-invalid': errors.has('user name'),
                                }"
                                autocomplete="no"
                                placeholder="Enter user name"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="First Name"
                                    label-for="first-name"
                                >
                                    <b-form-input
                                        id="first-name"
                                        v-model="formData.firstName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="first name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('first name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter first name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-3"
                                    label="Last Name"
                                    label-for="last-name"
                                >
                                    <b-form-input
                                        id="last-name"
                                        v-model="formData.lastName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="last name"
                                        :class="{
                                            'is-invalid':
                                                errors.has('last name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter last name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            label="Email Address"
                            label-for="email-address"
                        >
                            <b-form-input
                                id="email-address"
                                v-model="formData.email"
                                v-validate="{
                                    required: true,
                                    email: true,
                                }"
                                name="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                                autocomplete="no"
                                placeholder="Enter email address"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-5"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Enable OTP on login"
                            label-for="OTP"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.hasOTP"
                                    v-validate="{
                                        required: true,
                                    }"
                                    :options="boolVal"
                                    name="otp"
                                    :class="{
                                        'is-invalid': errors.has('otp'),
                                    }"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Role"
                            label-for="role"
                        >
                            <b-form-select
                                id="role"
                                v-model="formData.roleId"
                                v-validate="{
                                    required: true,
                                }"
                                name="role"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('role'),
                                }"
                                :options="roles"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="data-segments">Data Segments</label>
                            <multiselect
                                v-model="selectedSegIds"
                                v-validate="{
                                    required: true,
                                }"
                                name="data segments"
                                label="code"
                                placeholder="Select data segment"
                                track-by="id"
                                :class="{
                                    'is-invalid': errors.has('data segments'),
                                }"
                                :options="dataSegments"
                                :multiple="true"
                                ><template slot="noResult"
                                    >No Record Found</template
                                ></multiselect
                            >
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="system-user-warning">
                            <i class="icon-error_outline"></i>
                        </div>
                        <div class="system-user-details">
                            <p>
                                We will send email to user to create password
                                and activate account.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
                <base-toast></base-toast>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import resource from '@/api/resource'

const roleApi = new resource('access-control/roles')
const dataSegmentApi = new resource('access-control/data-segments')

export default {
    components: {
        Multiselect,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            formData: this.initializeFormData(),
            roles: [{ value: null, text: 'Select Role' }],
            dataSegments: [],
            selectedSegIds: [],
            boolVal: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        title() {
            return this.selectedItem ? 'Modify System User' : 'Add System User'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            let self = this
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value._id
                let currentRole = _.find(this.roles, {
                    value: this.formData.roleId,
                })
                if (!currentRole) {
                    this.formData.roleId = null
                }
                if (!this.formData.dataSegmentIds.length) {
                    self.selectedSegIds.push({
                        code: 'All',
                        id: 'all',
                    })
                } else {
                    this.formData.dataSegments.forEach(function (val) {
                        self.selectedSegIds.push({
                            code: val.code,
                            id: val._id,
                        })
                    })
                }

                this.formData.profilePicture.fileName = value.avatar.fileName
                this.formData.profilePicture.originalName =
                    value.avatar.originalName
                this.formData.hasOTP = value.hasOTP
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
        selectedSegIds(val) {
            let allSelected = _.find(val, { id: 'all' })
            if (allSelected) {
                _.remove(val, function (n) {
                    return n.id != 'all'
                })
                this.dataSegments.forEach(function (ele) {
                    if (ele.id !== 'all') {
                        ele.$isDisabled = true
                    }
                })
            } else {
                this.dataSegments.forEach(function (ele) {
                    ele.$isDisabled = false
                })
            }
        },
    }, // End of Component > watch

    mounted() {
        // get datasegment and roles options list
        this.getOptionsList()
    },
    methods: {
        initializeFormData() {
            return {
                id: '',
                profilePicture: {
                    fileName: '',
                    originalName: '',
                },
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                roleId: null,
                hasOTP: null,
                dataSegmentIds: [],
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    this.formData.dataSegmentIds = _.map(
                        this.selectedSegIds,
                        'id'
                    )
                    if (this.formData.id) {
                        //update system user
                        await this.$store.dispatch(
                            'updateSystemUser',
                            this.formData
                        )
                    } else {
                        //add system user
                        await this.$store.dispatch(
                            'addSystemUser',
                            this.formData
                        )
                    }
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.selectedSegIds = []
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async getOptionsList() {
            let self = this
            //data segments list

            let dataSegmentList = await dataSegmentApi.list({
                status: 'active',
                ref: 'dropdown',
                perPage: 1000,
            })
            self.dataSegments = [{ code: 'All', id: 'all' }]
            dataSegmentList.data.data.forEach(function (val) {
                self.dataSegments.push({ code: val.code, id: val._id })
            })

            // Roles option list

            let rolesList = await roleApi.list()
            rolesList.data.data.forEach(function (val) {
                if (val.status !== 'archived') {
                    self.roles.push({ text: val.title, value: val.id })
                }
            })
        },
    },
}
</script>
